mod.modules.define("SECFilings", "BaseModule", function(fn) {
	"use strict";

	var cache = {
		// DOM
		$category: null,
		$year: null
	};

	fn.prototype.init = function (params) {
		this.base("init", params);

		cache.$category = $("select.secfilings-categories", this.el);
		cache.$year = $("select.secfilings-year", this.el);

		if (this.el.find("div.pager-wrap").length) {
			this.addPlugin("Plugin-Paging");
		}
	};

	fn.prototype.loadReports = function (e, $el) {
		this.reload({
			Category: cache.$category.val(),
			Year: cache.$year.val(),
            PageIndex: 0
		});
	};

	fn.prototype.events = {
		"button[data-action=getFilings]": {
			"click": function (e, $el) {
				this.loadReports(e, $el);
			}
		}
	};

});